module.exports = __webpack_public_path__ + "9f7b12e19e11dda5ffa5e45a804a9d06.MP3";